import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { MerchantRates } from "src/app/shared/models/FocusPay/FocusPayApplication.item";
import { FocusPayRate } from "src/app/shared/models/FocusPay/FocusPayRates.item";

@Component({
	selector: "app-application-payment-service-rates",
	templateUrl: "./application-payment-service-rates.component.html",
	styleUrls: ["../../focuspay.style.scss"],
})
export class ApplicationPaymentServiceRatesComponent implements OnInit {
	@Input() processingRates: MerchantRates;
	@Output() processingRatesEmitter = new EventEmitter<MerchantRates>();
	@Output() displayModal = new EventEmitter<string>();

	focuspayRates: FocusPayRate[];

	constructor(private focuslink: FocuslinkService) {}

	ngOnInit(): void {
		this.getRates();
	}

	async getRates() {
		const resp = await this.focuslink.focuspayRatesGet();
		this.focuspayRates = resp.map((i) => {
			const rate = new FocusPayRate(i);
			rate.applicationRate = this.processingRates[rate.name];
			return rate;
		});

		this.focuspayRates.sort((a, b) => (a.sortOrder > b.sortOrder ? 1 : -1));
	}
}
